module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "font-size-16 font-weight-600"
  }, [_vm._v("Pilih Bundle Subtes")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/ambis-test/create-bundle')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "append-icon": "mdi-magnify",
      "placeholder": "Masukan kata kunci pencarian",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.bundles,
      "search": _vm.search,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          attrs: {
            "small": "",
            "depressed": "",
            "color": "blew",
            "dark": ""
          },
          on: {
            "click": function($event) {
              return _vm.$emit('select', item)
            }
          }
        }, [_vm._v("\n                    Pilih\n                ")])]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('p', {
          staticClass: "my-2"
        }, [_vm._v("Hasil pencarian tidak ditemukan.")])])]
      },
      proxy: true
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb35e22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DialogSelectBundleSubtest.vue
// module id = 1450
// module chunks = 1